import { useLinkRelValue, useStoryblokLink } from "hooks";
import NextLink from "next/link";
import { Link as ChakraLink } from "@chakra-ui/react";
import type { LinkProps } from "./Link.d";

const Link = ({ children, href, target, linktype, styles, uuid }: LinkProps) => {
  const decodedHref = decodeURI(href);
  const relValue = useLinkRelValue(decodedHref, linktype);
  const link = {
    id: uuid,
    url: decodedHref,
    linktype,
    fieldtype: "multilink",
    cached_url: "",
  };
  const url = useStoryblokLink(link);

  if (linktype === "email")
    return (
      <ChakraLink as={NextLink} href={`mailto:${decodedHref}`} passHref sx={styles}>
        {children}
      </ChakraLink>
    );

  return (
    <ChakraLink as={NextLink} href={url} passHref rel={relValue} target={target} sx={styles}>
      {children}
    </ChakraLink>
  );
};

export default Link;
